import { ArticleCategoryStore } from './article-category.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class ArticleCategoryQuery extends BaseQuery {

    constructor(store: ArticleCategoryStore) {
        super(store);
    }
}
